import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage,showNotification, showAlert, catchHandler } from "../../utils/helpers";
import { status } from "../../utils/common";

const state = {
    notifications: [],
    notification: {},
    totalItems:0,

};

const getters = {
    index: state => notificationId => state.notifications.findIndex(i => i.notificationId === notificationId)
};

const mutations = {
    setNotifications: (state, r) => (state.notifications = r),
    setTotalItems: (state, r) => (state.totalItems = r),
    setNotification: (state, r) => (state.notification = r),
    approval: (state, index) => state.notifications[index].status = status.active,
    cancel: (state, index) => state.notifications[index].status = status.rejected,

};

const actions = {
    async getAll({ commit },params) {
        try {
            const paramsString = Object.entries(params)
            .filter(([, val]) => val !== null)
            .map(([key, val]) => `${key}=${val}`)
            .join("&");
            startLoading()
            const response = await dataService.notifications.getAll(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            commit("setNotifications", response.data.notifications);
            commit("setTotalItems", response.data.totalItems);

          
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async extension({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.notifications.extension(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);


            const index = getters.index(id);
            commit("approval", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },    
    async approval({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.notifications.approval(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);


            const index = getters.index(id);
            commit("approval", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async cancel({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.notifications.cancel(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);

            const index = getters.index(id);
            commit("cancel", index);
        } catch (error) {

            stopLoading()
            catchHandler(error);
        }
    },
    
    async getDetails({ commit }, id) {
        try {
            commit("setNotification", {});
            startLoading()
            const response = await dataService.notifications.getDetails(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setNotification", response.data.notification);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
